'use strict';

import settings from '../settings';
import { HttpContext } from '../utils/httpContext';
import { setToken } from '../utils/token';

class EsemenyNaptarService {
  async GetEsemenyek() {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/GetEsemenyek';
    const result = await HttpContext.post({ url });
    return result;
  }
  async GetEsemenyTipusok() {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/GetEsemenyTipusok';
    const result = await HttpContext.post({ url });
    return result;
  }
  async GetEsemenyJellegek() {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/GetEsemenyJellegek';
    const result = await HttpContext.post({ url });
    return result;
  }
  async EditEsemeny({ id }) {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/EditEsemeny';
    let data = { id };
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async SaveEsemeny(data) {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/SaveEsemeny';
    const result = await HttpContext.post({ url, data });
    return result;
  }
  async EsemenyTorlese({ id }) {
    const url = settings.baseUrl + 'Api/EsemenyNaptar/EsemenyTorlese';
    let data = { id };
    const result = await HttpContext.post({ url, data });
    return result;
  }
}

let instance = new EsemenyNaptarService();
export { instance as esemenyNaptarService };
